(() => {
  const node=document.getElementById('product-gallery-data');
  if(!node)return;
  const data=JSON.parse(node.textContent);
  if(!data.full||!data.certificate)return;
  function pair(){
    const wrap=document.createElement('span');wrap.className='included-pair';
    for(const [key,cls] of [['full','pair-art'],['certificate','pair-certificate']]){
      const img=document.createElement('img');img.src=data[key].src;img.alt=data[key].alt;img.className=cls;wrap.append(img);
    }
    return wrap;
  }
  const thumb=document.querySelector('[data-view="included"] .thumb-image');
  if(thumb)thumb.replaceChildren(pair());
  for(const id of ['main-art','lightbox-image']){
    const img=document.getElementById(id);if(!img)continue;
    const display=pair();img.after(display);
    const sync=()=>{const active=img.getAttribute('src')===data.included.src;display.hidden=!active;img.hidden=active;img.parentElement.classList.toggle('show-included',active);};
    new MutationObserver(sync).observe(img,{attributes:true,attributeFilter:['src']});sync();
  }
})();
